/* Capes guide layout helpers (snippets/capes-guide-article.liquid). Progressive enhancement:
   without JS the post still shows its text, links, FAQ and table. */
(function () {
  var root = document.querySelector('[data-capes-guide]');
  if (!root) return;
  var body = root.querySelector('.capes-guide__body');
  if (!body) return;

  // Wide tables scroll inside their own box on phones.
  body.querySelectorAll('table').forEach(function (t) {
    if (t.parentElement.classList.contains('capes-table-wrap')) return;
    var w = document.createElement('div'); w.className = 'capes-table-wrap';
    t.parentNode.insertBefore(w, t); w.appendChild(t);
  });

  // FAQ: each h3 + following paragraphs become a <details> item.
  body.querySelectorAll('.capes-faq').forEach(function (faq) {
    faq.querySelectorAll('h3').forEach(function (h, i) {
      var d = document.createElement('details'); var s = document.createElement('summary');
      s.textContent = h.textContent; d.appendChild(s); if (i === 0) d.open = true;
      var n = h.nextElementSibling;
      while (n && n.tagName !== 'H3' && n.tagName !== 'SCRIPT') { var next = n.nextElementSibling; d.appendChild(n); n = next; }
      h.parentNode.replaceChild(d, h);
    });
  });

  // Product markers become cards (name + photo from the live store; no price).
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  body.querySelectorAll('.capes-product[data-handle]').forEach(function (el) {
    var handle = el.getAttribute('data-handle');
    var note = el.textContent.split('—').slice(1).join('—').trim();
    if (note) note = note.charAt(0).toUpperCase() + note.slice(1);
    fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var a = document.createElement('a'); a.className = 'capes-card'; a.href = base + 'products/' + p.handle;
        var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="" width="88" height="88" loading="lazy">' : '<span></span>';
        var t = document.createElement('span'); t.className = 'capes-card__t'; t.textContent = p.title;
        a.innerHTML = img; var box = document.createElement('span'); box.appendChild(t);
        if (note) { var s = document.createElement('span'); s.className = 'capes-card__s'; s.textContent = note; box.appendChild(s); }
        var b = document.createElement('span'); b.className = 'capes-card__b'; b.textContent = 'See options'; box.appendChild(b);
        a.appendChild(box); el.innerHTML = ''; el.appendChild(a);
      })
      .catch(function () {});
  });

  // Highlight the current section in the contents list.
  var links = root.querySelectorAll('.capes-guide__aside .capes-guide__toc a');
  if (links.length && 'IntersectionObserver' in window) {
    var map = {}; links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.removeAttribute('aria-current'); });
        var a = map[e.target.id]; if (a) a.setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '0px 0px -70% 0px' });
    body.querySelectorAll('h2[id]').forEach(function (h) { io.observe(h); });
  }
})();
